import { Button } from "@/components/ui/button";

interface ErrorFallbackProps {
  error: unknown;
  resetError: () => void;
}

export const ErrorFallback = ({ error, resetError }: ErrorFallbackProps) => {
  const message = error instanceof Error ? error.message : "An unexpected error occurred.";

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="max-w-md w-full text-center space-y-4">
        <h1 className="text-2xl font-semibold">Something went wrong</h1>
        <p className="text-muted-foreground text-sm">
          We have been notified and are looking into it. You can try again or head back home.
        </p>
        <p className="text-xs text-muted-foreground/80 font-mono break-words">{message}</p>
        <div className="flex gap-2 justify-center pt-2">
          <Button onClick={resetError} variant="default">
            Try again
          </Button>
          <Button
            onClick={() => {
              window.location.href = "/";
            }}
            variant="outline"
          >
            Go home
          </Button>
        </div>
      </div>
    </div>
  );
};
